<template lang="pug">
  .component-selectize-driver
    loading-spinner(v-if="loading")
    selectize(v-if="options", :value="value", :selectedValue="selectedValue" :options="options", value-field="id", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Federation")
</template>

<script>
  import Selectize from "../../../Selectize"
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice"
  import LoadingSpinner from "../../../LoadingSpinner";

  export default {
    name: "SelectizeFederation",
    extends: BaseSelectize,
    components: {LoadingSpinner, Selectize},
    data() {
      return {
        loading: true,

        searchableFields: ['id', 'name']
      }
    },
    created() {
      this.dataLoader()
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div><small>${item.id}</small></div><div>${item.name}</div></div>`
      },
      dataLoader(page, resultsPerPage, search) {
        KeplerBackofficeSdk.federations.list(page, -1).all((data) => {
          this.options = data.items
          this.loading = false
        })
      },
      renderTemplate(item, escape) {
        return `<div>${item.name}</div>`
      }
    },
    props: ['selectedValue']
  }
</script>

<style></style>



// WEBPACK FOOTER //
// SelectizeFederation.vue?69f827c0